import { User } from '@/api/types/user';
import { UserModel } from '@/models/user';

export function transformUser(user: User) : UserModel {
  return {
    email: user.email
  };
}
